import {
  START_GET_LEARNING_ROUTE,
  SUCCESS_GET_LEARNING_ROUTE,
  ERROR_GET_LEARNING_ROUTE,
  START_EDIT_LEARNING_ROUTE,
  SUCCESS_EDIT_LEARNING_ROUTE,
  ERROR_EDIT_LEARNING_ROUTE,
  START_CREATE_LEARNING_ROUTE,
  SUCCESS_CREATE_LEARNING_ROUTE,
  ERROR_CREATE_LEARNING_ROUTE,
  START_GET_LEARNING_ROUTE_BY_ID,
  SUCCESS_GET_LEARNING_ROUTE_BY_ID,
  ERROR_GET_LEARNING_ROUTE_BY_ID,
  ILearningRouteState
} from "../types";

const initialState: ILearningRouteState = {
  learningRoutes: [],
  msg: null,
  error: false,
  loading: false,
  currentLearningRoute: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_GET_LEARNING_ROUTE:
    case START_CREATE_LEARNING_ROUTE:
    case START_EDIT_LEARNING_ROUTE:
      return {
        ...state,
        msg: null,
        error: false,
        loading: true,
      };

    case SUCCESS_GET_LEARNING_ROUTE:
      return {
        ...state,
        learningRoutes: action.payload,
        msg: null,
        error: false,
        loading: false,
      };

    case SUCCESS_CREATE_LEARNING_ROUTE:
      return {
        ...state,
        learningRoutes: [...state.learningRoutes, action.payload],
        msg: null,
        error: false,
        loading: false,
      };

    case START_GET_LEARNING_ROUTE_BY_ID:
      return {
        ...state,
        loading: true,
        msg: null,
        error: false,
        currentLearningRoute: null,
      };

    case SUCCESS_GET_LEARNING_ROUTE_BY_ID:
      return {
        ...state,
        loading: false,
        currentLearningRoute: action.payload,
        error: false,
        msg: null,
      };

    case ERROR_GET_LEARNING_ROUTE_BY_ID:
      return {
        ...state,
        loading: false,
        currentLearningRoute: null,
        error: true,
        msg: action.payload,
      };

    case SUCCESS_EDIT_LEARNING_ROUTE:
      return {
        ...state,
        learningRoutes: state.learningRoutes.map(route =>
          route.id === action.payload.id ? action.payload : route
        ),
        msg: null,
        error: false,
        loading: false,
      };

    case ERROR_GET_LEARNING_ROUTE:
    case ERROR_CREATE_LEARNING_ROUTE:
    case ERROR_EDIT_LEARNING_ROUTE:
      return {
        ...state,
        msg: action.payload,
        error: true,
        loading: false,
      };

    default:
      return state;
  }
}
